import React from "react";
import ServiceTagsSection from "./ServiceTagsSection";
import "./Contact2.css";

export const About = (props) => {
  return (
    <div className="container">
      <ServiceTagsSection />
      <div id="about" className="text-center" style={{ paddingTop: "15px" }}>
        <div>
          <div className="section-title">
            <h2>À propos</h2>
          </div>
          <div className="row">
            {/* Mobile image block */}
            <div className="d_yes">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <img
                  src="img/apropos.jpg"
                  className="img-responsive"
                  style={{
                    height: "85%",
                    width: "85%",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  alt=""
                />
              </div>
            </div>

            {/* Desktop images column */}
            <div className="col-xs-12 col-md-6 d_non">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  marginRight: "30px",
                  marginTop: "30px",
                }}
              >
                <img
                  src="img/apropos.jpg"
                  className="img-responsive"
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  alt=""
                />
              </div>

              <br />
              <br />

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  marginLeft: "30px",
                  marginBottom: "20px",
                }}
              >
                <img
                  src="img/apropos2.jpg"
                  className="img-responsive"
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  alt=""
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  marginLeft: "70px",
                }}
              >
                <img
                  src="img/apropos3.jpg"
                  className="img-responsive"
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  alt=""
                />
              </div>
            </div>

            {/* Text + why column */}
            <div className="col-xs-12 col-md-6">
              <div className="about-text" style={{ marginTop: "0px" }}>
                <p
                  className="text-justify d_non"
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.8",
                    fontWeight: "700",
                  }}
                >
                  L’EXPERT RÉNOVATION est une entreprise spécialisée dans la
                  rénovation intérieure et extérieure, accompagnant aussi bien
                  les particuliers que les professionnels dans leurs projets
                  d’aménagement, de transformation ou de modernisation de leurs
                  espaces.
                  <br />
                  Implantée à Saint-Clair-de-la-Tour (38110), notre équipe
                  qualifiée intervient sur tous types de bâtiments :
                  appartements, maisons, bureaux, commerces et locaux
                  professionnels.
                  <br />
                  Grâce à un savoir-faire multidisciplinaire, nous prenons en
                  charge l’ensemble des corps de métier : électricité,
                  plomberie, isolation, placo, carrelage, peinture, décoration,
                  menuiserie légère, rénovation complète, création ou rénovation
                  de salles de bain et cuisines, ainsi que des projets
                  d’extension ou d’aménagement d’espaces supplémentaires.
                  <br />
                  Nous proposons des solutions sur mesure, alliant esthétique,
                  qualité technique et durabilité, tout en garantissant un
                  accompagnement sérieux du premier devis jusqu’à la réception
                  du chantier.
                  <br />
                  Notre priorité : offrir à chaque client des travaux conformes,
                  réalisés dans les délais et dans le respect de leur budget,
                  avec une communication transparente et un suivi rigoureux.
                </p>

                <p
                  className="text-justify container d_yes"
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.8",
                    fontWeight: "700",
                  }}
                >
                  L’EXPERT RÉNOVATION est une entreprise spécialisée dans la
                  rénovation intérieure et extérieure, accompagnant aussi bien
                  les particuliers que les professionnels dans leurs projets
                  d’aménagement, de transformation ou de modernisation de leurs
                  espaces.
                  <br />
                  Implantée à Saint-Clair-de-la-Tour (38110), notre équipe
                  qualifiée intervient sur tous types de bâtiments :
                  appartements, maisons, bureaux, commerces et locaux
                  professionnels.
                  <br />
                  Grâce à un savoir-faire multidisciplinaire, nous prenons en
                  charge l’ensemble des corps de métier : électricité,
                  plomberie, isolation, placo, carrelage, peinture, décoration,
                  menuiserie légère, rénovation complète, création ou rénovation
                  de salles de bain et cuisines, ainsi que des projets
                  d’extension ou d’aménagement d’espaces supplémentaires.
                  <br />
                  Nous proposons des solutions sur mesure, alliant esthétique,
                  qualité technique et durabilité, tout en garantissant un
                  accompagnement sérieux du premier devis jusqu’à la réception
                  du chantier.
                  <br />
                  Notre priorité : offrir à chaque client des travaux conformes,
                  réalisés dans les délais et dans le respect de leur budget,
                  avec une communication transparente et un suivi rigoureux.
                </p>

                <div className="about-why-wrapper">
                  <div className="about-why-card lo">
                    <h3 className="about-why-title">
                      Pourquoi nous faire confiance ?
                    </h3>

                    <div className="list-style">
                      <div
                        className="col-lg-12 col-sm-12 col-xs-12"
                        style={{ textAlign: "justify", padding: 0 }}
                      >
                        <ul className="about-why-list">
                          {props.data
                            ? props.data.Why.map((d, i) => (
                                <li
                                  key={`${d}-${i}`}
                                  className="about-why-item"
                                >
                                  <span className="about-why-icon">✓</span>
                                  <span className="about-why-item-text">{d}</span>
                                </li>
                              ))
                            : "loading"}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
